import api from "../api";

/**
 * /admin/all-sonda-data ucu sunucu tarafinda sayfalidir (varsayilan 50, tavan 200).
 * Parametresiz cagrildiginda TUM sistemdeki ilk 50 kaydi dondurur; bu yuzden bir
 * calismanin butun sondalarina ihtiyac duyan yerler (T-Sonda, T-Sablon Sonda Excel,
 * sahadaki "benzer sonda" listesi) bu yardimciyi kullanmalidir.
 *
 * Sayfalamayi desteklemeyen eski backend'lerde de calisir: pageCount gelmezse
 * tek turda biter ve donen tum kayitlar job_id'ye gore suzulur.
 */
export async function fetchAllSondasByJob(jobId) {
  const LIMIT = 200;
  const all = [];
  let page = 1;
  let pageCount = 1;

  do {
    const res = await api.get("/admin/all-sonda-data", {
      params: { page, limit: LIMIT, job_id: jobId },
    });

    if (!res.data?.success) break;

    const chunk = Array.isArray(res.data.data) ? res.data.data : [];
    all.push(...chunk);

    pageCount = Number(res.data.pageCount) || 1;
    if (chunk.length === 0) break;
    page++;
  } while (page <= pageCount);

  // Eski backend job_id parametresini yok sayabilir, bu yuzden burada da suzuyoruz.
  return jobId == null ? all : all.filter((s) => s.job_id === jobId);
}

export default fetchAllSondasByJob;
